<template>
<div>
  <div :class="['tags-wrapper', { 'screen-lg': onTabletUp }]">
    <div :class="['tag', { 'screen-lg': onTabletUp }]" @click="selectAllItems(allOpt)" v-if="this.selectAll && this.allOpt">
      <div class="tag-name">
        {{ this.allOpt.name }}
      </div>
    </div>

    <span class="tag-group" v-for="(item, i) in items" :key="i">
      <div :class="['tag', { selected: item.isSelected, 'screen-lg': onTabletUp }]" @click="selectItem(item)">
        <div class="tag-name">
          {{ item.name }}
        </div>
      </div>
    </span>
  </div>
</div>
</template>

<script>
export default {
  name: 'checkbox-tags',
  components: {},
  props: {
    allOpt: {
      type: Object,
    },
    isEmbed: {
      type: Boolean,
    },
    items: {
      type: Array,
      required: true,
    },
    selectAll: {
      type: Boolean,
    },
    size: {
      type: String,
      default: 'lg',
    },
    onTabletUp: {
      type: Boolean,
    },
    validateSelect: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    validate(item) {
      const hasSelection = this.items.some((item) => item.isSelected === true) || item.isSelected ? true : false;
      this.$emit('is-valid', hasSelection);
    },
    async selectItem(item) {
      if (this.allOpt && this.allOpt.isSelected) {
        this.allOpt.isSelected = false;
      }

      await this.toggleCheck(item);

      if (this.validateSelect) {
        this.validate(item);
      }
    },
    async selectAllItems(item) {
      await this.toggleCheck(item);
      if (item.isSelected) {
        await this.items.forEach((item) => (item.isSelected = true));
      } else {
        await this.items.forEach((item) => (item.isSelected = false));
      }

      if (this.validateSelect) {
        this.validate(item);
      }
    },
    toggleCheck(item) {
      item.isSelected = !item.isSelected;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.tags-wrapper {
  margin-bottom: 1rem;
  width: 100%;

  .tag-group {
    display: inline-block;

    .tag {
      background: rgba(white, 0.5);
      border: 1px solid $color-grocery-list-border;
      border-radius: 0.7rem;
      color: $color-blackText;
      font-size: 1.3rem;
      margin: 0 0.5rem 1rem;
      padding: 1.5rem;
      text-align: center;

      .tag-name {
        color: $color-grocery-list-item-text;
        font-size: 1.6rem;
        line-height: 1;
      }

      &:hover,
      &.selected {
        background-color: $color-action;
        color: $color-blackText;
        cursor: pointer;
      }
    }
  }
}
</style>
